import { useCallback, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import CreateIcon from "@material-ui/icons/Create";

import { dateTimeZoneConverter } from "../../../../../../utils/commonFunctions/date";
import { TDisease } from "../../../../../../@types/disease.types";
import { DataGrid, DataGridColumn, GridAction } from "../../../../../shared";

type DiseaseRow = TDisease & {
	_id?: string;
	disease_name?: string;
	disease_details?: string;
	createdAt?: string;
};

const DiseaseManagementGrid = ({ gridData }: { gridData: TDisease[] }): JSX.Element => {
	const navigate = useNavigate();

	const routeToEdit = useCallback(
		(diseaseId: string | null | undefined) => {
			if (!diseaseId) {
				return;
			}
			navigate(`/settings/edit-disease/${diseaseId}`);
		},
		[navigate]
	);

	const columns = useMemo<DataGridColumn<DiseaseRow>[]>(
		() => [
			{ key: "disease_name", header: "Disease name" },
			{ key: "disease_details", header: "Disease details" },
			{
				key: "createdAt",
				header: "Created date",
				width: "14rem",
				render: (row) => (row.createdAt ? (dateTimeZoneConverter(row.createdAt) as string) : "N/A")
			},
			{
				key: "action",
				header: "Edit",
				width: "6rem",
				align: "center",
				stopRowClick: true,
				render: (row) => (
					<GridAction icon title="Edit disease" onClick={() => routeToEdit(row._id)}>
						<CreateIcon fontSize="small" />
					</GridAction>
				)
			}
		],
		[routeToEdit]
	);

	return (
		<DataGrid
			rows={gridData as DiseaseRow[]}
			columns={columns}
			getRowId={(row, index) => row._id ?? String(index)}
			emptyMessage="No diseases added yet."
		/>
	);
};

export default DiseaseManagementGrid;
